import React from 'react';

const Checkmark = ({ className, fill = 'white' }) => (React.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", viewBox: "0 0 14 14", fill: "none" },
    React.createElement("path", { d: "M11.6668 3.7915L5.25016 10.2082L2.3335 7.2915", stroke: fill, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })));

export { Checkmark as default };
//# sourceMappingURL=Checkmark.mjs.map
